/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ list: NonNullable<unknown> }} Sorx_Undelivered_AlsoInputs */

const en_sorx_undelivered_also = /** @type {(inputs: Sorx_Undelivered_AlsoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Also: ${i?.list}`)
};

const id_sorx_undelivered_also = /** @type {(inputs: Sorx_Undelivered_AlsoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Juga: ${i?.list}`)
};

/**
* | output |
* | --- |
* | "Also: {list}" |
*
* @param {Sorx_Undelivered_AlsoInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const sorx_undelivered_also = /** @type {((inputs: Sorx_Undelivered_AlsoInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sorx_Undelivered_AlsoInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sorx_undelivered_also(inputs)
	return en_sorx_undelivered_also(inputs)
});